import { crudMessage } from "./crud-message";
import { modalImportClients } from "./modal-import-clients";
import { modalMyModels } from "./modal-my-models";

export const message = {
	header: {
		isCreate: {
			title: "Nuevo mensaje",
			subtitle:
				"Seleccione un local de su organización para listar el grupo de clientes destinatario.",
		},
		isEdit: {
			title: "Editar mensaje programado",
			subtitle: "Cambie el local para seleccionar otro grupo de destinatarios.",
		},
	},
	places: "Locales",
	emptyWhatsappList:
		"Ningún local de la organización tiene números registrados en WhatsApp. Póngase en contacto con el equipo de atención de Zig y solicite el registro de un número para poder enviar mensajes por WhatsApp a sus clientes.",
	import: "Importar hojas de Excel",
	myModels: "Mis modelos",
	columnsTableClients: {
		name: "Nombre del Cliente",
		cpf: "CPF",
		ticket: "Ticket promedio",
		presences: "Visitas",
	},
	modalSaveGroup: {
		title: "Guardar grupo",
		text:
			"Guarde los filtros aplicados para crear un grupo de clientes y facilitar el envío de SMS en el futuro.",
		filtersList: "Filtros aplicados",
		groupName: {
			title: "Nombre del grupo",
			placeholder: "Seleccione un nombre para el nuevo grupo de clientes",
		},
	},
	footer: {
		save: "Guardar cambio y editar mensaje",
		foward: "Avanzar",
		confirmWithoutSaveGroup: "Avanzar sin guardar grupo",
		confirmWithSaveGroup: "Guardar grupo y avanzar",
	},
	infos: {
		title: "Responsabilidad de información de clientes",
		text:
			"Al importar la lista de contactos de los clientes, con el propósito de enviar SMS, usted confirma que los mismos aceptaron recibir los mensajes, según la Ley General de Protección de Datos (LGPD).",
		agree: "Entendido",
	},
	sheet: {
		title: "Lista de Clientes (ejemplo)",
		columns: {
			name: "Nombre",
			phone: "Teléfono",
			cpf: "CPF",
			observation: "Observación",
		},
	},
	crudMessage,
	modalImportClients,
	modalMyModels,
};
